import { Balloon, DatePicker, Radio } from '@alifd/next';
import moment from 'moment';
import React, { useContext } from 'react';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';
function ActivityTime() {
  const { task, taskParams, setTaskParams, pageDisable } = useContext(ActivityContext);
  const disabledDate = function (date, view) {// 设置禁止选择的时间
    return date.valueOf() < moment().subtract(1, 'day').valueOf();
  };
  return (
    <div className={styles['cardBox']}>
      <div className={styles['titleBox']}>活动时效：</div>
      <Radio.Group
        direction={'hoz'}
        value={taskParams.taskTimeType}
        disabled={pageDisable}
        onChange={(v) =>
          setTaskParams({ 
            ...taskParams,
            taskTimeType: +v,
            startTime:'',
            endTime:'',
          })
        }
      >
        <Radio value={1}>
          <Balloon.Tooltip
            align='t'
            trigger={'不限制'}
          >
            不限制任务时效，则该任务将会一直进行;如需关闭可到任务列表中手动关闭任务
          </Balloon.Tooltip>
        </Radio>
        <Radio value={2}>
          <div className={styles['radioSmallBox']}>
            <Balloon.Tooltip
              align='t'
              trigger={'自定义任务时间'}
            >
              该任务会在设定的开始时间开始执行任务，在到达结束时间自动关闭任务。
            </Balloon.Tooltip>
            <DatePicker.RangePicker
              placeholder={['开始日期','结束日期']}
              value={[taskParams.startTime, taskParams.endTime]}
              format='YYYY-MM-DD'
              onChange={(v)=>{
                setTaskParams({
                  ...taskParams,
                  startTime: v[0] ? v[0] : '',
                  endTime: v[1] ? v[1] : '',
                })
              }}
              disabledDate={disabledDate}
              disabled={pageDisable || +taskParams.taskTimeType !== 2}
            />
          </div>
        </Radio>
      </Radio.Group>
    </div>
  );
}

export default ActivityTime;
